import { MeetingSessionOvenMediaReceiver } from "@kalyzee/kast-web-sdk";
import { ExpertView, PedagogyView } from "../interfaces/populatedData";
import { MeetingSessionStatus } from "@kalyzee/kast-web-sdk/websocket";
import { expertWebcamName, pedagogyWebcamName } from "./webcam";


export const getAudioContextForAudioMixer = () => {
  (window as any).audioContextMixer = (window as any).audioContextMixer ?? new AudioContext();
  return (window as any).audioContextMixer as AudioContext;
};

export const getAudioContextForVolumeAnalyzer = () => {
  (window as any).audioContextAnalyzer = (window as any).audioContextAnalyzer ?? new AudioContext();
  return (window as any).audioContextAnalyzer as AudioContext;
}

export const getExpertAudioValidator = (view: ExpertView | undefined) => {
  return (session: MeetingSessionOvenMediaReceiver) => {
    const sessionStatus = session.data?.session?.status;
    const sessionId = session.data?.session?.id;
    if (!sessionId) return false;
    if (sessionStatus !== MeetingSessionStatus.RUNNING) return false;

    if (!view) return false;

    const studentData = view.students.find((data) => data.session.id === sessionId);
    if (studentData) return studentData.audio;

    const expertData = view.experts.find((data) => data.session.id === sessionId);

    if (expertData) {
      // Audio disabled for whole session
      if (!expertData.audio) return false;
      // Maybe audio needs to be disabled for this specific media session
      if (view.type === "highlight") {
        // expert webcam is visible only for tab "hightlight"
        return session.data.mediaSession.name === expertWebcamName || session.data.mediaSession.name === pedagogyWebcamName;
      } else {
        // other devices than webcam can only be visible in normal mode
        return session.data.mediaSession.name !== expertWebcamName;
      }
    }
    return false;
  }
};

export const getPedagogyAudioValidator = (view: PedagogyView | undefined) => {
  return (session: MeetingSessionOvenMediaReceiver) => {
    const sessionStatus = session.data?.session?.status;
    const sessionId = session.data?.session?.id;
    if (!sessionId) return false;
    if (sessionStatus !== MeetingSessionStatus.RUNNING) return false;

    if (!view) return false;

    const studentData = view.students.find((data) => data.session.id === sessionId);
    if (studentData) return studentData.audio;

    const expertData = view.experts.find((data) => data.session.id === sessionId);
    if (expertData) return expertData.audio;

    return false;
  }
};